
const makeCleanId = (id) => {
  return id.toLowerCase().replace(/[^A-Za-z0-9]/g, '');
};

export default makeCleanId;
